"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const Colors_1 = require("components/styled/Colors");
const Fonts_1 = require("components/styled/Fonts");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
exports.Input = styled_components_1.default.input `
  appearance: none;
  background: ${Colors_1.WHITE};
  border-radius: 100px;
  border: 1px solid ${Colors_1.NEVADA};
  box-sizing: border-box;
  color: ${Colors_1.NEVADA};
  font-family: ${Fonts_1.SpaceMonoFontStack};
  font-size: 14px;
  height: 48px;
  letter-spacing: 0;
  margin-bottom: 16px;
  outline: none;
  padding-left: 24px;
  width: 100%;

  :-webkit-autofill {
    -webkit-box-shadow: inset 0 0 0px 9999px ${Colors_1.WHITE};

    ${ScreenSizes_1.TABLET_PORTRAIT} {
      border: 1px solid ${Colors_1.KARL};
      -webkit-box-shadow: inset 0 0 0px 9999px ${Colors_1.KARL};
    }
  }

  ::-webkit-input-placeholder {
    line-height: normal;
  }

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    background: ${Colors_1.KARL};
    border: 1px solid transparent;
    height: 58px;
    margin: 0;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    font-size: 16px;
    line-height: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/styled/Input.ts